import { SHOW_PRICING } from './lib/flags';

export const ROUTES = {
  home: '/',
  features: '/features',
  howItWorks: '/how-it-works',
  download: '/download',
  changelog: '/changelog',
  pricing: '/pricing',
  faq: '/faq',
  privacy: '/privacy',
  terms: '/terms',
  legalDpa: '/legal/dpa',

  authSignIn: '/auth/sign-in',
  authSignUp: '/auth/sign-up',
  authCallback: '/auth/callback',
  authForgot: '/auth/forgot',
  authReset: '/auth/reset',
  authCheckEmail: '/auth/check-email',

  account: '/account',
  accountStats: '/account/stats',
  accountDevices: '/account/devices',
  accountPreferences: '/account/preferences',
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RoutePath = (typeof ROUTES)[RouteKey];

// Public, indexable marketing routes (consumed by sitemap.xml generator).
// Excludes auth/* and account/* (private, noindex).
export const PUBLIC_ROUTE_PATHS: readonly RoutePath[] = [
  ROUTES.home,
  ROUTES.features,
  ROUTES.howItWorks,
  ROUTES.download,
  ROUTES.changelog,
  ...(SHOW_PRICING ? ([ROUTES.pricing] as const) : []),
  ROUTES.faq,
  ROUTES.privacy,
  ROUTES.terms,
  ROUTES.legalDpa,
];
